import React, { createContext, FC, useContext, useEffect, useState } from 'react';

const FEATURE_FLAG_API_URL = '/api/v31/reference/feature_flags';

const TogglesContext = createContext<Map<string, string> | null>(null);

export const useToggles = (): Map<string, string> | null => {
  const toggles = useContext(TogglesContext);
  if (!toggles) {
    throw new Error('useToggles must be used inside TogglesProvider');
  }
  return toggles;
};

export const TogglesProvider: FC = ({ children }) => {
  const [toggles, setToggles] = useState<Map<string, string> | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchToggles = async (): Promise<void> => {
      try {
        const response = await fetch(FEATURE_FLAG_API_URL, { method: 'GET' });

        response
          .json()
          .then((data: Map<string, string>) => {
            return new Map(Object.entries(data));
          })
          .then(
            (toggleMap) => setToggles(toggleMap),
            () => setToggles(new Map()),
          );
      } catch (e) {
        setToggles(new Map());
        setError(true);
      }
    };

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetchToggles();
  }, []);

  if (error) {
    throw new Error('Could not fetch toggles');
  }

  if (toggles) {
    return <TogglesContext.Provider value={toggles}>{children}</TogglesContext.Provider>;
  }

  return <div data-testid="toggles-context-provider">Loading...</div>;
};
